"use client";
import {useRouter} from "next/navigation";
import React, {useState, useEffect} from "react";
import styles from "./page.module.css";
import List from "./list";
import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import LoginNetManager from "@/Core/Login/LoginNetManager";
import UserMgr from "@/Core/UserMgr";
import Load from "@/app/_components/Load/Load";
import {useUser} from "@/app/context/UserContext";
import {RedeemRecordInfo} from "@/Core/Redeem/redeemEntity";

export default function RedeemRecordUI() {
    const router = useRouter();
    const [dataList, setDataList] = useState<RedeemRecordInfo[]>([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [maxPage, setMaxPage] = useState(1);
    const user = useUser();
    const userInfo = user.baseInfo;

    useEffect(() => {
        if (UserMgr.hasTokenOk(user.token)){
            console.log("RedeemRecordRedeemRecord");
            // setDataList(dataList);
            getNewRedeemRecord();
        }
    }, [user.token]);

    if (!UserMgr.hasTokenOk(user.token)) return <Load/>

    const getNewRedeemRecord = () => {
        RedeemManager.GetRedeemRecord(page, pageSize, (totalPage: number, result) => {
            setMaxPage(totalPage);
            //TODO UI 有可能列表为空，这时候还一直在转圈
            if (result && result.length > 0) {
                setDataList(result)
            }
        });
    }

    return (
        <>
            <div className={styles.page}>
                <List listData={dataList}></List>
            </div>
        </>
    )
}
